<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Uw huis moet geschilderd worden?</h1>
      <p>
        Is uw huis toe aan een likje verf? Of moet er in en om uw huis het één
        en ander geschilderd worden? Maar heeft u geen idee waar te beginnen?
        Wij zullen u stap voor stap helpen zodat u een goede keuze kan maken.
      </p>

      <h1>Offertes van schildersbedrijven vergelijken?</h1>
      <p>
        Misschien is het allemaal wat veel werk, alles zelf verven. In dat geval
        kunt u een schildersbedrijf inhuren. Maar welk bedrijf is nou het beste?
        Wat gaat het kosten? Welke levert de beste kwaliteit?
      </p>
      <p>
        Via Schildervergelijker.nl kunt u makkelijk, snel en kosteloos
        verschillende offertes aanvragen. Zo ziet u snel, makkelijk en
        moeiteloos welk schildersbedrijf het beste bij u past.
      </p>

      <h2>Schilderwerk door een vakman</h2>
      <p>
        Door uw huis te schilderen beschermt u uw huis tegen weersinvloeden of
        beschadigingen. Ook ziet uw huis na het schilderen er weer mooi uit.
        Wanneer u uw huis wilt laten schilderen door een vakman kunt u het
        voorwerk ook zelf doen zodat u kosten bespaart. U kunt zelf al gaten
        vullen, verf afbranden en schuren.
      </p>
      <p>
        De schilders zijn vakmannen die de juiste kennis en ervaring hebben.
        Wanneer u voor een vakschilder kiest, zijn een aantal punten belangrijk;
        Allereerst hebben de schilders van u een zo uitgebreid mogelijke
        beschrijving nodig van de materialen / muren die beschilderd dienen te
        worden, met hierbij de staat waarin ze verkeren. Daarnaast geeft u aan
        welke kleuren u wilt, welke afmetingen de onderdelen hebben en om welke
        hoeveelheid muren of oppervlaktes het gaat. Tevens geeft u aan of het om
        de binnenkant- en of buitenkant van uw huis gaat. Bij het schilderen van
        buitenmuren zijn de omstandigheden en gebruikte materialen nog
        belangrijker dan binnen. U kunt foto’s meesturen zodat de schilder een
        nog beter beeld krijgt. Vervolgens komen de schilders bij u thuis om al
        uw wensen te bespreken. Maak vervolgens duidelijke afspraken met de
        schilder en leg deze vast op papier.
      </p>
      <p>
        De schilders verwijderen en reinigen oude verflagen, stucwerk wordt
        gerepareerd, houtwerk wordt geschuurd, hersteld en voorbehandeld,
        oppervlaktes worden met diepgrond behandeld en plafonds worden met
        hoogwaardige latexverf beschilderd. Sommige schilders kunnen u
        muurschilderingen aanbieden.
      </p>

      <h2>Verfkleur</h2>
      <p>
        Het kiezen van de juiste kleur verf is één van de belangrijkste
        onderdelen bij het schilderen. Bekijk allereerst de hoeveelheid
        lichtinval in uw woning. Wanneer u muren heeft waar veel licht op
        schijnt, kies dan voor glanzende verf. Hierdoor reflecteert het licht
        meer waardoor de wanden een mooi effect krijgen. Wanneer er minder licht
        binnenkomt, kan een normale muurverf goed uitpakken. Verfsoorten kunnen
        ook gemengd worden zodat u uw eigen kleur creëert. In verfwinkels zijn
        kleurenwaaiers beschikbaar zodat u ideeën voor uw huis op kunt doen.
      </p>
      <p>
        Voor het buitenschilderwerk wordt vaak hoogglanslak gebruikt, aangezien
        vuil hier minder snel op kan hechten. Schilders kunnen u ook adviseren
        over soorten verf en kleuren.
      </p>

      <h2>Kosten</h2>
      <p>
        De kosten van schilderwerk worden aan de hand van verschillende aspecten
        bepaald;
      </p>
      <ul>
        <li>
          De kosten van voorwerk zijn afhankelijk van het materiaal en de staat
          waarin het verkeerd.
        </li>
        <li>De totale oppervlakte van het te schilderen gedeelte.</li>
        <li>
          Het seizoen waarin geschilderd wordt. In de winter zijn de kosten van
          schilderwerk meestal lager i.v.m. dalbezetting van de schilder.
          Hierdoor zal in de winter de offerteprijs goedkoper zijn dan in de
          zomer.
        </li>
        <li>De keuze van de verf.</li>
      </ul>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Informatie over schildersbedrijven?',
      headDescription:
        'Meer informatie over Schildervergelijker.nl vind je op deze informatie pagina.',
      path: '/schilder-informatie',
    }
  },
}
</script>
